
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { get } from '@/services/http';

@Component
export default class DraftPoPicker extends Vue {
  @Prop({ type: Number, default: null }) readonly supplierId!: number | null;
  @Prop({ type: Number, default: null }) readonly value!: number | null;

  private pos: any[] = [];
  private search = '';
  private loading = false;
  private searchTimeout: number | null = null;

  mounted() {
    this.fetch();
  }

  @Watch('supplierId')
  onSupplierIdChange() {
    this.fetch();
  }

  @Watch('search')
  onSearchChange() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = window.setTimeout(() => this.fetch(), 500);
  }

  async fetch() {
    this.loading = true;
    try {
      const params: any = { status: 'draft' };
      if (this.supplierId) params.supplierId = this.supplierId;
      if (this.search) params.search = this.search;
      const res: any = await get('/purchase_orders', params);
      this.pos = (res.data && res.data.purchaseOrders) || [];
      this.$emit('results-count', this.pos.length);
    } catch (e) {
      this.pos = [];
      this.$emit('results-count', 0);
    } finally {
      this.loading = false;
    }
  }

  beforeDestroy() {
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
  }

  private formatDate(iso: string): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString();
  }
}
